"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LanguageSelect = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DropDown = require("../../icons/navigation/DropDown");

var _colors = require("../../theme/colors");

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    container: _defineProperty({
      cursor: 'pointer',
      width: '4rem',
      marginRight: '1rem'
    }, theme.breakpoints.down('sm'), {
      marginLeft: 'auto'
    }),
    label: {
      width: '3.5rem',
      justifyContent: 'flex-end',
      display: 'flex',
      alignItems: 'center'
    },
    dropDownIcon: {
      marginLeft: '0.5rem'
    },
    menuList: {
      padding: '0.125rem 0'
    },
    menuItem: {
      fontSize: '0.75rem',
      lineHeight: '1.5rem',
      borderRadius: '0.5rem',
      height: '1.5rem',
      minHeight: '1.5rem',
      width: 'calc(100% - 2rem)',
      margin: '0.5rem auto',
      '&:hover': {
        backgroundColor: _colors.colors.softGreen
      }
    },
    popper: {
      zIndex: function zIndex(props) {
        return props.zIndex ? props.zIndex : 0;
      }
    },
    popperWrapper: {
      borderRadius: '1rem',
      width: '14.5rem',
      marginTop: '0.5rem',
      padding: '0.5rem 0'
    },
    selectedLanguage: _defineProperty({
      fontSize: '0.75rem'
    }, theme.breakpoints.down('xs'), {
      fontWeight: 'bold'
    })
  };
});

var LanguageSelect = function LanguageSelect(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      languageSelectOpen = _useState2[0],
      setLanguageSelectOpen = _useState2[1];

  var languages = props.languages,
      currentLanguage = props.currentLanguage,
      handleLanguageSelect = props.handleLanguageSelect,
      anchorRef = props.anchorRef,
      supportedLanguages = props.supportedLanguages;
  var classes = useStyles(props);

  var handleLanguageSelection = function handleLanguageSelection(language) {
    setLanguageSelectOpen(false);
    handleLanguageSelect === null || handleLanguageSelect === void 0 ? void 0 : handleLanguageSelect(language);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentLanguage ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    "data-testid": "language-select-label",
    onClick: function onClick() {
      return languageSelectOpen !== undefined && setLanguageSelectOpen ? setLanguageSelectOpen(!languageSelectOpen) : null;
    },
    className: classes.label
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    "data-testid": "selected-language",
    className: classes.selectedLanguage,
    ref: anchorRef
  }, (supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.some(function (l) {
    return l.key === currentLanguage;
  })) ? supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.map(function (l) {
    return l.key === currentLanguage ? l.label : null;
  }) : currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.toUpperCase()), /*#__PURE__*/_react["default"].createElement(_DropDown.DropDown, null))), /*#__PURE__*/_react["default"].createElement(_core.Popper, {
    open: languageSelectOpen,
    role: undefined,
    placement: "bottom-end",
    transition: true,
    anchorEl: anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current,
    className: classes.popper
  }, function (_ref) {
    var TransitionProps = _ref.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(_core.Grow, TransitionProps, /*#__PURE__*/_react["default"].createElement(_core.Paper, {
      className: classes.popperWrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.ClickAwayListener, {
      onClickAway: function onClickAway() {
        return setLanguageSelectOpen ? setLanguageSelectOpen(false) : null;
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.MenuList, {
      className: classes.menuList
    }, languages === null || languages === void 0 ? void 0 : languages.map(function (l, idx) {
      return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        onClick: function onClick() {
          return l && handleLanguageSelect ? handleLanguageSelection(l) : null;
        },
        key: idx,
        className: classes.menuItem
      }, (supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.some(function (lang) {
        return lang.key === l;
      })) ? supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.map(function (lang) {
        return lang.key === l ? lang.label : null;
      }) : l === null || l === void 0 ? void 0 : l.toUpperCase());
    })))));
  })) : null);
};

exports.LanguageSelect = LanguageSelect;
var _default = LanguageSelect;
exports["default"] = _default;